import { Org } from 'src/interfaces/onboarding.types';

export const isOrgMember = (
  targetOrgId: string,
  userActiveOrgs?: Org[],
): boolean => {
  if (!userActiveOrgs?.length) return false;

  return !!userActiveOrgs.find((org) => org.sourcedId === targetOrgId);
};
